import type { LucideIcon } from "lucide-react"

export interface Starter {
  text: string
  icon: LucideIcon
}

interface StarterListProps {
  starters: Starter[]
  onSelect: (text: string) => void
}

/**
 * Empty-state starter prompts, shared by the Assistant and Tender Chat.
 * Left-aligned full-contrast rows so they read as actions, not examples.
 */
export function StarterList({ starters, onSelect }: StarterListProps) {
  return (
    <div className="w-full max-w-xl">
      <div className="px-3 pb-1.5 text-meta font-medium text-left">Start with</div>
      <div className="flex flex-col gap-0.5">
        {starters.map(({ text, icon: Icon }) => (
          <button
            key={text}
            type="button"
            onClick={() => onSelect(text)}
            className="flex items-center gap-2.5 rounded-lg px-3 py-2.5 text-left text-sm text-foreground hover:bg-muted/50 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-1"
          >
            <Icon className="h-4 w-4 shrink-0 text-muted-foreground" />
            <span className="flex-1">{text}</span>
          </button>
        ))}
      </div>
    </div>
  )
}
